import gql from 'graphql-tag';

export const LoyaltyCardFragment = gql`
  fragment LoyaltyCardFragment on LoyaltyCard {
    barcode
    cardFormat
    cardId
    details {
      points
      rewardsTier
    }
  }
`;
